import { hubAxios } from "@helpers/lib/axios";
import { HUB_ENDPOINTS } from "@memorang/constants/urls";
import type { AIResponsePayload, AssessmentRunStatus } from "@memorang/types";

export type SessionAssessmentItemStatus = {
	itemId: number;
	status: AssessmentRunStatus | "MISSING";
	aiResponse?: AIResponsePayload;
};

export type SessionAssessmentStatusResponse = {
	items: SessionAssessmentItemStatus[];
};

export const fetchSessionAssessmentStatus = async (
	sessionId: number,
	itemIds: number[],
): Promise<SessionAssessmentStatusResponse> => {
	const { data } = await hubAxios.post<SessionAssessmentStatusResponse>(
		HUB_ENDPOINTS.SESSION_ASSESSMENT_STATUS,
		{ sessionId, itemIds },
	);
	return data;
};
